import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Chip from '../Common/Chip';
import SelectCourse from './SelectCourse';

import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';

class SelectCourses extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            courseIds: this.props.courseIds || [],
            courses: []
        };
    }

    componentDidMount() {
        this.onSelect = this.onSelect.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCourseChange = this.onCourseChange.bind(this);

        this.listener = CourseStore.addListener(this.onCourseChange);

        if (!!this.props.courseIds.length) {
            CourseActions.getSimplifiedList(this.props.courseIds);
        }
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {
        return (
            <div>
                <SelectCourse
                    label="Include courses"
                    onSelect={(name, id) => this.onSelect(name, id)}
                    clearOnSelect
                />
                <div className="cent-form-chips">
                    {this.state.courses.map((course) => {
                        return (
                            <Chip
                                key={course.id}
                                label={course.name}
                                onDelete={() => this.onDelete(course.id)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    onSelect(name, id) {
        if (this.state.courseIds.includes(id)) { return null; }
        this.setState({
            courses: [...this.state.courses, {id, name}],
            courseIds: [...this.state.courseIds, id]
        });
        this.props.onSelect(name, id);
    }

    onDelete(courseId) {
        this.setState({
            courses: this.state.courses.filter((e) => e.id !== courseId),
            courseIds: this.state.courseIds.filter((id) => id !== courseId)
        });
        this.props.onDelete(courseId);
    }

    onCourseChange() {
        const courses = !!this.state.courseIds.length && CourseStore.getByIds(this.state.courseIds);
        if (!!courses) {
            this.setState({courses});
        }
    }
}

SelectCourses.propTypes = {
    courseIds: PropTypes.arrayOf(PropTypes.number),
    onSelect:  PropTypes.func,
    onDelete:  PropTypes.func
};

SelectCourses.defaultProps = {
    courseIds: [],
    onSelect:  () => {},
    onDelete:  () => {}
};

export default SelectCourses;
